import React, { useEffect, useState } from "react";
import * as classes from "./PartnersCarousel.module.scss";
import { useSelector } from "react-redux";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import pauseicon from '../../assets/icons/pauseicon.svg';
import playicon from '../../assets/icons/play-solid.svg';

function PartnersCarousel({ dynamicHeading }) {
  const cmsData = useSelector((state) => state.HomeCMSData);
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      document?.getElementById("partner")?.setAttribute("aria-hidden", "false");
    }
  }, []);

  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  const handleTogglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <div
      className={classes.partnerSec}
      //role="region"
      id="partner"
      aria-label={cmsData?.partners_title}
    >
      <h3 className={classes.patnerTitle} aria-level={6} aria-label={cmsData?.partners_title}>
        {cmsData?.partners_title}
      </h3>
      <div className={classes.logoSec}>
        <div className="mainsec">
          {dynamicHeading && dynamicHeading?.partners_block && (
            <div className={classes.carouselContainer}>
              <Carousel
                autoPlay={isPlaying}
                autoPlaySpeed={1000}
                arrows={false}
                infinite={true}
                responsive={responsive}
                className="container"
              >
                {dynamicHeading?.partners_block?.map((item, index) => (
                  <div className={classes.items} key={index}>
                    <img
                      src={item?.logo?.data?.url}
                      alt={item?.logo?.data?.alternativeText}
                    />
                  </div>
                ))}
              </Carousel>
            </div>
          )}
        </div>
      </div>
      <div className={classes.carouselControls}>
        {isPlaying ? (
          <img role='button' className={classes.pauseicons} src={pauseicon} alt="Pause" onClick={handleTogglePlay} />
        ) : (
          <img role='button' className={classes.pauseicons} src={playicon} alt="Play" onClick={handleTogglePlay} />
        )}
      </div>
    </div>
  );
}

export default PartnersCarousel;

